<template>
  <div class="prod-container">
    <div class="page-header">
      <md-breadcrumb :dataSource="cateParents" @breadcrumbClick="breadcrumbClick"></md-breadcrumb>
    </div>
    <div v-loading="loading == -1" class="content-view">
      <div class="left-view md-el-aside position-relative" v-resize-width>
        <div class="aside-view">

          <div class="list-view" :class="item.Params.id === dataDetail.id ? 'active' : ''" v-for="item in dataList" :key="item.ID" @click="fileDetail(item)">
            <img
              :src="require('@/assets/images/tree/file.png')"
              class="img"
              alt=""
              srcset=""
            />
            <span :title="item.Params.name || item.Params.name2">{{ item.Params.name || item.Params.name2 }}</span>

            <div class="edit-view">
              <i class="drag-edit" title="拖拽可放置指定的目录中"><svg-drag :width="18" :height="18" fill="#606266"></svg-drag></i>
              <i title="删除" class="el-icon-delete" @click.stop="_dataDelete(item)"></i>
            </div>
          </div>

          <el-empty description="暂无文件" :image-size="100" v-if="dataList.length <= 0"></el-empty>
        </div>
      </div>
      <div class="right-view">
        <file-content :dataSource="dataDetail"></file-content>
      </div>
    </div>
  </div>
</template>

<script>
  import {MessageBox} from 'element-ui';
  import {RespurceService,CommonService,DragService} from "@/service"
  import {Category} from '@/libs'
  //引入组件
  import MdBreadcrumb from "@/components/md-breadcrumb/md-breadcrumb.vue";
  import SvgDrag from '@/components/svg/drag.vue';
  import FoldIcon from '@/components/icon/fold-icon.vue';
  import FileContent from '../home/file-content.vue';

  export default {
    props: {},
    components: {
      MdBreadcrumb,
      SvgDrag,
      FileContent,
      FoldIcon
    },
    data() {
      return {
        loading: 1,
        cateParents: [{DirName: '我的开放资源', DirID: 0, TreeID: 0}],
        dirId: 0,
        dataList: [],
        total: 0,
        loading: 0, //状态  -1加载中 0 未加载  1 加载完成
        page: 1,
        pageSize: 20,
        dataDetail: {},
      };
    },
    mounted() {
      this.loadList();
    },
    methods: {
      breadcrumbClick(value) {
        this.$parent.$refs.catalogTree.select(`list_${value.DirID}`);
      },
      fileDetail(value) {
        this.dataDetail = { ...value.Params, subcount: 0 };
      },
      dirChanged(dirId, cateParents = []) {
        this.dirId = dirId;
        this.cateParents = cateParents.reverse();
        this.dataDetail = {};
        this.loadList();
      },
      async loadList(isFirst = false) {
        //加载产品列表
        this.loading = -1;
        isFirst && (this.page = 1)
        const res = await RespurceService.getResListByCategoryId(
          Category.ResourceFavoriteDir,
          Category.OutsourcingDir,
          this.dirId,
          this.page,
          this.pageSize
        );
        this.loading = 1;
        if (res.code === 0) {
          this.dataList = res.data.list.map(item => {
            let Params = {};
            try {
              Params = JSON.parse(item.Params);
            } catch (error) {}
            return {
              DirID: this.dirId,
              ...item,
              Params,
            }
          });
          this.total = res.data.count;
        }
        this.initDrag();
      },

      initDrag() {
        this.$nextTick(() => {
          DragService.dragToTree({
            table: document.getElementsByClassName('left-view')[0],
            wrapper: '.aside-view',
            handle: ".drag-edit",
            delay: 1,
            primaryKey: "ID",
            datas: this.dataList,
            category: Category.OutsourcingDir,
            callback: this.dragCallback,
            dirCategory: Category.ResourceFavoriteDir,
            operateAreaId: [Category.ResourceFavoriteDir],
          })
        })
      },

      dragCallback(args = {}) {
        this.loadList();
        this.$parent.dragDataCallback(args.treeId, this.dirId, Category.LectoFavoriteDir);
      },

      _dataDelete(value) {
        MessageBox.confirm('确定删除吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await CommonService.dataDelete(Category.ResourceFavoriteDir, Category.OutsourcingDir, this.dirId, value.ID);
          this.$parent.dragDataCallback(0, this.dirId, Category.LectoFavoriteDir);
          this.loadList();
        })
      },
    }
  };
</script>

<style lang="less" scoped>
.prod-container{
  flex: 1;
  display: flex;
  flex-direction: column;
}
.page-header{
  border-bottom: 1px solid @line-strong-color;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
  /deep/ .md-breadcrumd{
    padding: 5px;
  }
}
.content-view{
  flex: 1;
  display: flex;
  height: calc(100vh - 53px - 43px);
}
.left-view{
  height: 100%;
  width: 200px;
  min-width: 28px;
  max-width: 400px;
  cursor: e-resize;
  padding-right: 4px;
  background-color: #eeeeee;
  .aside-view{
    width: 100%;
    height: 100%;
    background: #ffffff;
    overflow-y: auto;
    overflow-x: hidden;
    cursor:default;
  }
}
.right-view{
  flex: 1;
  position: relative;
}
.list-view{
  color: #0989c5;
  display: flex;
  align-items: center;
  padding: 6px 10px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .img{
    height: 14px;
    margin-right: 4px;
  }
  &.active{
    background-color: #e6f3f9;
  }
  &:hover{
    background-color: #F5F7FA;
    .edit-view{
      right: 8px;
    }
  }
}
.edit-view{
  display: flex;
  align-items: center;
  position: absolute;
  right: -46px;
  top: 0;
  height: 100%;
  color: #606266;
  transition: all 0.3s;
  i{
    font-size: 18px;
    cursor: pointer;
  }
  .drag-edit{
    margin-right: 4px;
    margin-top: 2px;
    cursor: move;
  }
}
</style>
